import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  toastr.success(response.data.msg);
  if (typeof context.isInitializedErrors !== 'undefined') {
    context.isInitializedErrors = false;
  }
};

// When the request fails
const failed = (error, context) => {
  context.showToasterError(error);
  if (typeof context.isInitializedErrors !== 'undefined') {
    context.isInitializedErrors = true;
  }
};

export default (id, rental, context) => {
    return Vue.$http.put(`/rentals/${id}`, rental)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            } else {
                failed();
            }
    }).catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/rental/update.js